import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { addToCart, addMultipleToCart, launchCartFlyout, addCTOToCart, updateCart } from '../../utility/utility-actions';
import PurchaseButton, { _UnconnectedPurchaseButton } from './purchase-button';
import { Helpers } from '../../core/src/helpers';
import { fetchXSellProducts } from '../../xsell/xsell-actions';
import { fetchPrices } from '../product-actions';

const mapStateToProps = (state, ownProps) => {

	const { product, addOns } = ownProps;
	const { productData } = state;
	const { productInfo, ctoConfigurations } = productData;
	return {
		showSelector: ownProps.showSelector,
		product,
		price: Helpers.getProductPrice(product, productInfo.productPrices, true, ctoConfigurations),
		jumpid: ownProps.jumpid,
		xSellModalBlocked: state.xSell.blocked,
		xSellModalIsOpen: state.xSell.isOpen,
		xSellOpenedSkus: state.xSell.xSellOpenedSkus,
		addToCartFlyoutVisible: state.cartInfo.addToCartFlyoutVisible,
		isccf: (state.userData.profileData || {}).isccf,
		addOns
	};
};

const mapDispatchToProps = dispatch => {
	return {
		updateCart: (item, qty) => dispatch(updateCart(item, qty)),
		addCTOToCart: (product, quantity, blockFlyout, followRedirect) => dispatch(addCTOToCart(product, quantity, blockFlyout, followRedirect)),
		addToCart: (product, quantity, blockFlyout, addOns, variant, baseProductSku, xsellType, metricParams) => dispatch(addToCart(product, quantity, blockFlyout, addOns, variant, baseProductSku, xsellType, metricParams)),
		addMultipleToCart: (products, quantity, blockFlyout, options, baseProductSku, xsellType) => dispatch(addMultipleToCart(products, quantity, blockFlyout, options, baseProductSku, xsellType)),
		fetchXSellProducts: (product, limit, source) => dispatch(fetchXSellProducts(product, limit, source)),
		fetchPrices: Helpers.memoize((id) => dispatch(fetchPrices([id]))),
		launchCartFlyout: () => dispatch(launchCartFlyout()),
	};
};

const WithAddToCart = (Component) => {
	return (props) => {
		return <Component {...props} />;
	}
};
const withAddToCart = compose(
	connect(null, mapDispatchToProps),
	WithAddToCart);


const withPurchaseButton = compose(
	connect(mapStateToProps, mapDispatchToProps),
	(Component) => {
		return (props) => {
			return <Component {...props} />;
		}
	}
);

export { _UnconnectedPurchaseButton, withAddToCart, withPurchaseButton };
export default connect(mapStateToProps, mapDispatchToProps)(PurchaseButton);
